import { api } from "@/axios";
import Vue from "vue";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
import messageTemplateManager from "@/utils/messageTemplateManager";
import { getCache, setCache } from "@/utils/cacheDB";

const state = {
  patients: [],
  patient: {},
  history: [],
  patient_id: "",
  searchResult: {},
  searchHistory: [],
  doctorPatients: [],
  registerPatient: {},
  doctors: [],
  filterPatients: [],
  discountLater: [],
  tokens: [],
  queueReports: [],
  invoice: {},
  isQueueReportsLoading: false,
  invoiceNumber: "",
  isLoading: false,
  historyStatus: null,
  addPatientStatus: null,
  attachments: []
};

const mutations = {
  set_loading(state, val) {
    state.isLoading = val;
  },
  set_patients(state, val) {
    state.patients = val;
  },
  set_details(state, val) {
    state.patient = val;
  },
  set_history(state, val) {
    state.history = val.history;
    state.patient = val.patientDetails;
    state.attachments = val.attachments;
  },
  set_search_results(state, val) {
    state.searchResult = val;
    state.patient_id = val[0]?.id;
  },
  doctor_patients(state, val) {
    state.doctorPatients = val;
  },
  search_patients(state, val) {
    state.filterPatients = val;
  },
  set_register_patient(state, val) {
    state.patient_id = val.id;
    state.registerPatient = val;
  },
  set_doctors(state, val) {
    state.doctors = val;
  },
  set_history_results(state, val) {
    state.searchHistory = val;
  },
  setLaterDiscount(state, val) {
    state.discountLater = val;
  },
  set_tokens(state, val) {
    state.tokens = val;
  },
  setInvoice(state, val) {
    state.invoice = val;
  },
  setQueueReports(state, val) {
    state.queueReports = val;
  },
  setQueueReportsLoading(state, val) {
    state.isQueueReportsLoading = val;
  },
  set_invoiceNumber(state, val) {
    state.invoiceNumber = val;
  },
  set_history_status(state, val) {
    state.historyStatus = val;
  },
  addPatient_status(state, val) {
    state.addPatientStatus = val;
  }
};

const actions = {
  async addPatient({ commit, dispatch, rootState }, { payload, vm, sendSms }) {
    if (permissionsMiddleWare("Create Patient")) {
      console.log(sendSms, "sendSms");
      const isOther = rootState?.auth?.user?.isOther;
      commit("set_loading", true, { root: true });
      return await new Promise((resolve, reject) => {
        api
          .post("/patient", payload)
          .then(res => {
            commit("addPatient_status", res.status);
            const patient = res?.data?.result?.patient;

            // Use template system for patient registration message
            const registrationMessage = messageTemplateManager.getNextPatientRegistrationTemplate(
              {
                patientName: patient.name,
                mrNo: patient.mr_no
              }
            );

            const message = {
              to: patient.contactNumber,
              url: "",
              message: registrationMessage,
              reportType: "Registration",
              patientId: patient.id
            };
            // const message = {
            //   // to: undefined,
            //   to: patient.contactNumber,
            //   text: `You have been successfully registered with Medi-Rad Imaging at Family Health Hospital, Jutiyal Gilgit. Your Medical Record Number is ${patient.mr_no}. Please remember this number for your future visits of radiology related services.`,
            // };
            commit("set_register_patient", patient);
            vm.$toasted.show("Patient added successfully").goAway("3000");
            // Send SMS asynchronously without blocking other operations
            if (
              message.to &&
              message.to !== undefined &&
              isOther === 1 &&
              sendSms === true
            ) {
              dispatch(
                "reports/sendSms",
                { sms: message, vm: vm },
                { root: true }
              );
            }

            // Continue with patient list refresh without waiting for SMS
            dispatch("listPatients").then(() => {
              commit("set_loading", false, { root: true });
              resolve(res);
            });
          })
          .catch(error => {
            commit("set_loading", false, { root: true });
            reject(error);
          });
      });
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Create Patient"
        )
        .goAway("3000");
    }
  },
  listPatients({ commit }, val) {
    return new Promise((resolve, reject) => {
      api
        .get("/patient", {
          params: {
            ...val
          }
        })
        .then(res => {
          commit("set_patients", res.data.result);
          commit("set_loading", false, { root: true });
          resolve(res);
        })
        .catch(error => {
          commit("set_loading", false, { root: true });
          reject(error);
        });
    });
  },
  updateTokenStatus({ commit }, payload) {
    console.log(payload);

    return new Promise((resolve, reject) => {
      api
        .put(`/tokens/update-status`, payload)
        .then(res => {
          resolve(res);
          commit("set_loading", false, { root: true });
        })
        .catch(error => {
          reject(error);
          commit("set_loading", false, { root: true });
        });
    });
  },
  async patientDetails({ commit }, payload) {
    commit("set_loading", true, { root: true });
    try {
      const result = await api.get(`/patient/${payload}`);
      commit("set_details", result.data.result);
      return result.data.result;
    } finally {
      commit("set_loading", false, { root: true });
    }
  },
  async updateDetails({ commit }, { id, user, historyId }) {
    if (permissionsMiddleWare("Update Patient")) {
      try {
        commit("set_loading", true, { root: true });

        await api.put(
          `/patient/${id}${historyId ? `?historyId=${historyId}` : ""}`,
          user
        );
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action : Update Patient"
        )
        .goAway("3000");
    }
  },
  async cancelAppointment({ dispatch, commit }, { id, historyId, payload }) {
    if (permissionsMiddleWare("Cancel Appointment")) {
      try {
        commit("set_loading", true, { root: true });

        const res = await api.put(`/patient/appointment/${id}`, payload, {
          params: { history_id: historyId }
        });
        if (res.status == 200) {
          Vue.toasted.success(res.data.message).goAway("3000");
        }

        await dispatch("listPatients");
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Cancel Appointment"
        )
        .goAway("3000");
    }
  },
  async addHistory({ commit }, payload) {
    try {
      commit("set_loading", true, { root: true });
      const req = { ...payload };
      // history.patientId = state.patient_id || state.searchResult.id;
      if (req.patientId) {
        await api.post("/history", req).then(res => {
          if (res.status === 201) {
            commit("set_history_status", res.status);
          }
        });
      }
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async listHistory({ commit }, id) {
    try {
      commit("set_loading", true, { root: true });
      const result = await api.get(`/history/${id}`);
      commit("set_history", result.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async searchHistory({ commit }, query) {
    try {
      commit("set_loading", true, { root: true });
      const result = await api.get(
        `history/patient/${query.searchText}/${query.branchId}`
      );
      commit("set_history_results", result.data && result.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async searchPatient({ commit }, query) {
    if (permissionsMiddleWare("Search Patient")) {
      const result = await api.get(`/patient/search/${query}`);
      commit("set_search_results", result.data.result);
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Search Patient"
        )
        .goAway("3000");
    }
  },
  async doctorsPatient({ commit, rootState }, payload) {
    if (permissionsMiddleWare("List Patient By Doctor")) {
      try {
        commit("set_loading", true, { root: true });
        const id = rootState.auth && rootState.auth.user.id;
        const result = await api.get(`/patient/doctor/${id}`, {
          params: { ...payload }
        });
        commit("doctor_patients", result.data.result);
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: List Patient By Doctor"
        )
        .goAway("3000");
    }
  },
  async doctorsPatientSearch({ commit }, query) {
    if (permissionsMiddleWare("Search Patient By Branch")) {
      try {
        commit("set_loading", true, { root: true });
        const result = await api.get(`/patient/patientMR/${query}`);
        commit("doctor_patients", result.data.result);
        commit("search_patients", result.data.result);
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Search Patient By Branch"
        )
        .goAway("3000");
    }
  },
  async listDoctors({ commit }) {
    // Cache-first: data lives in IndexedDB until logout — no API call
    // when the cache is populated
    const cached = await getCache("userDoctors");
    if (cached && cached.length > 0) {
      commit("set_doctors", cached);
      return;
    }
    const doctors = await api.get(`/user/doctors`);
    commit("set_doctors", doctors.data.result);
    await setCache("userDoctors", doctors.data.result);
  },
  async searchTodayList({ commit }, query) {
    try {
      commit("set_loading", true, { root: true });
      const result =
        query.filterId !== undefined
          ? await api.get(
              `/patient?mr_no=${query.searchVaue}&service_head=${query.filterId}`
            )
          : await api.get(`/patient?mr_no=${query.searchVaue}`);
      commit("set_patients", result.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  laterDiscount({ commit, dispatch }, { historyId, discount }) {
    if (permissionsMiddleWare("Later Discount")) {
      commit("set_loading", true, { root: true });
      return new Promise((resolve, reject) => {
        api
          .put(
            `/history/discount-applied/${historyId}`,
            discount ? { discount: discount } : "registrationId"
          )
          .then(res => {
            commit("setLaterDiscount", res.data.result);
            commit("set_loading", false, { root: true });
            dispatch("listPatients");
            resolve(res);
          })
          .catch(err => {
            reject(err);
            commit("set_loading", false, { root: true });
          });
      });
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Later Discount"
        )
        .goAway("3000");
    }
  },

  async getQueueReports({ commit, rootState }, params) {
    if (permissionsMiddleWare("Patient Queue")) {
      try {
        commit("setQueueReportsLoading", true);
        const id = rootState.auth.user.id;
        const doctorId = params.doctor_id;
        const response = await api.get(
          `/patient/patient-queue-by-doctor/${doctorId ? doctorId : id}`,
          {
            params
          }
        );
        commit("setQueueReports", response.data.result);
        commit("setQueueReportsLoading", false);
      } catch (error) {
        commit("setQueueReportsLoading", false);
        console.log({ error });
      }
    } else {
      Vue.toasted
        .info(
          `This action cannot be performed by you due to insufficient authorization. Action:- <b>Find Queue</b>`
        )
        .goAway("3000");
    }
  },

  async getTokenNo({ commit }, payload) {
    const response = await api.post("/tokens", payload);
    commit("set_tokens", response.data.result);
  },
  async getInvoiceNumber({ commit }, query) {
    const response = await api.get(`/history/get-last-invoice-no/${query}`);
    commit("set_invoiceNumber", response.data.result);
  },
  resetReceptionist({ commit }) {
    commit("set_details", {});
    commit("set_history", []);
  },
  printInvoice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (permissionsMiddleWare("History By Invoice Number")) {
        api
          .get(
            `history/invoice-number?invoice_no=${payload.invoice_no}&patient_id=${payload.patiantId}`
          )
          .then(response => {
            commit("setInvoice", response?.data?.result);
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : History By Invoice Number",
          { duration: 3000 }
        );
        reject(new Error("Permission denied"));
      }
    });
  }
};

const getters = {
  patientList: state => state.patients,
  isLoading: state => state.isLoading,
  detailsPatient: state => state.patient || {},
  getHistory: state => state.history,
  searchResult: state => state.searchResult,
  doctorPatients: state => state.doctorPatients,
  registerPatient: state => state.registerPatient,
  doctorsList: state => state.doctors,
  historySearchResults: state =>
    state.searchHistory ? state.searchHistory : [],
  filterPatients: state => (state.filterPatients ? state.filterPatients : []),
  discountLater: state => state.discountLater,
  tokens: state => state.tokens,
  invoice: state => state.invoice,
  queueReports: state => state.queueReports,
  isQueueReportsLoading: state => state.isQueueReportsLoading,
  invoiceNumber: state => state.invoiceNumber,
  historyStatus: state => state.historyStatus,
  addPatientStatus: state => state.addPatientStatus,
  getAttachments: state => state.attachments
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
